<div>
    <!-- Cuentas propias -->
    <div class="col-12">
        <div class="row mb-4">
            <!-- Fecha inicio -->
            <div class="col-sm-6">
              <label for="startDate" class="form-label">Fecha inicio</label>
              <input type="date" id="startDate" [(ngModel)]="startDate" class="form-control" />
            </div>
    
            <!-- Fecha fin -->
            <div class="col-sm-6">
              <label for="endDate" class="form-label">Fecha final</label>
              <input type="date" id="endDate" [(ngModel)]="endDate" class="form-control" />
            </div>
    
            <div class="col-sm-6">
                <label for="ownAccount" class="form-label fw-semibold">Cuenta bancaria propia</label>
                <select class="form-select" [(ngModel)]="selectedOwnAccount">
                    <option
                    *ngFor="let account of filterAccounts"
                    [ngValue]="account.accountNumber">
                    {{ account.alias }} - {{ account.accountNumber }}
                    </option>
                </select>
            </div>
            <div class="col-sm-6 d-flex align-items-end justify-content-end">
              <button class="btn btn-primary w-100" (click)="openConfirmModal()" [disabled]="!selectedOwnAccount || loading">
                <i class="fa fa-search" *ngIf="!loading"></i>
                <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loading"></span> Buscar
              </button>
            </div>
        </div>

        <!-- Tabla -->
    <div class="table-responsive">
        <table class="table table-hover align-middle">
            <thead class="table-light">
            <tr>
                <th>Fecha/Hora</th>
                <th>Descripción</th>
                <th>(-) Debito</th>
                <th>(+) Credito</th>
                <th>Monto Disponible</th>
                <th>Accion</th>
            </tr>
            </thead>
            <tbody>
                <ng-container  *ngIf="!loading">
                    <tr *ngFor="let item of pagination.filter">
                        <td>{{item.date}} {{item.time}}</td>
                        <td class="truncate-5-lines">
                            <div style="width: 300px;">
                                {{item.transactionDescription}}
                            </div>
                        </td>
                        <td>{{item.debitAmount | currency:"Q" }}</td>
                        <td>{{item.creditAmount | currency:"Q" }}</td>
                        <td>{{item.availableAmount | currency:"Q" }}</td>
                        <td>
                            <div>
                                <span class="text-info clickeable" tooltip="Ver Detalles del Lote" (click)="getVoucher(item.reference, item.sequential)">
                                    <i class="fa fa-file-invoice" *ngIf="!loadingVoucher[item.sequential]"></i>
                                    <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingVoucher[item.sequential]"></span>
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr class="tr-middle" *ngIf="pagination.total.length==0">
                        <td colspan="6" class="">
                            <span class="text-center">
                                No se encuentras resultados
                            </span>
                        </td>
                    </tr>
                </ng-container>
                <tr class="tr-middle" *ngIf="loading">
                    <td colspan="6" class="">
                        <span class="display-5 text-center">
                            <app-loading-animation [height]="'3rem'"></app-loading-animation>
                            Cargando...
                        </span>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>

        <!-- Paginación -->
        <!-- <app-simple-pagination [elements]="paginationApplications" [sizes]="sizes" (changed)="getPaginationMovements()"></app-simple-pagination> -->
         <app-pagination-custom [elements]="pagination"></app-pagination-custom>
    </div>
</div>
<app-modal-dialog
  [title]="'Confirmar Consulta de Movimientos'"
  [show]="confirmModalVisible"
  [showHeader]="true"
  [showFooter]="false"
  size="md"
  position="center"
  (closed)="onCancelSearch()"
>
  <div modal-body>
    <div class="alert alert-warning d-flex align-items-center">
      <i class="fa fa-exclamation-triangle me-2"></i>
      <span>Revisa cuidadosamente los datos antes de consultar los movimientos.</span>
    </div>

    <p>
      <strong>Fecha inicio:</strong>
      <span class="text-muted">{{ movementPreview?.startDate }}</span>
    </p>

    <p>
      <strong>Fecha final:</strong>
      <span class="text-muted">{{ movementPreview?.endDate }}</span>
    </p>

    <div class="card shadow-sm mb-2">
      <div class="card-body p-2">
        <h6 class="fw-bold text-primary mb-1">Cuenta</h6>

        <div *ngIf="movementPreview?.account">
          <div>
            {{ movementPreview.account.accountNumber }} - {{ movementPreview.account.alias }}
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm mb-2">
      <div class="card-body p-2">
        <h6 class="fw-bold text-primary mb-1">Código</h6>

        <div *ngIf="!showInputCode">
          <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
            Solicitar Código
            <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
          </button>
        </div>

        <div *ngIf="showInputCode">
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              [(ngModel)]="code2fa">

            <button class="btn btn-success" (click)="pastClipboard()">
              <i class="fa fa-clipboard"></i>
            </button>
          </div>

          <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
            Volver a solicitar código
            <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="card-body p-3">
        <div class="col">
          <button class="btn btn-secondary btn-block" (click)="onCancelSearch()">
            Cancelar
          </button>

          <button
            class="btn btn-primary btn-block"
            (click)="onConfirmSearch()"
            *ngIf="showInputCode && code2fa"
            [disabled]="loading">
            Finalizar
          </button>
        </div>
      </div>
    </div>
  </div>
</app-modal-dialog>